<template>
  <div class="footer-all">
    <div class="ndata-footer">
<!--      <el-divider class="footer-divider"/>-->
<!--      <el-row>-->
<!--        <el-col :span="12" :xs="24">-->
      <div style="display: flex;padding-top: 20px">
          <div class="footer-content" style="width: 62%">
            <div style="color: #ffffff;font-weight: bold;font-size: 16px">
              联系我们
            </div>
<!--            <div v-if="siteIntro" >-->
<!--              <span  class="footer-font">主办单位：{{siteIntro}}</span>-->
<!--            </div>-->
<!--            <div v-if="websit && websit.guidance">-->
<!--              <span  class="footer-font">指导单位：{{websit.guidance}}</span>-->
<!--            </div>-->
<!--            <div v-if="websit && websit.undertake">-->
<!--              <span  class="footer-font">承办单位：{{websit.undertake}}</span>-->
<!--            </div>-->
<!--            <div v-if="websit && websit.siteAddress">-->
<!--               <span  class="footer-font">地址：{{websit.siteAddress}}</span>-->
<!--            </div>-->
<!--            <div  v-if="websit && websit.zipCode">-->
<!--              <span   class="footer-font">邮编：{{websit.zipCode}}</span>-->
<!--            </div>-->
            <div  v-if="websit && websit.contactTelephone" style="position: relative">
              <img :src="require('@/assets/competition/telephone.png')" width="15px" style="position: absolute;top: 11px">
              <span   class="footer-font" style="margin-left: 20px">客服电话：</span>
              <div class="footer-font">
                <span v-html="websit.contactTelephone"></span>
              </div>
<!--              <div  class="footer-font">-->
<!--                (周一至周五 9:00-18:00)-->
<!--              </div>-->
            </div>
            <div  v-if="websit && websit.contactMail" style="position: relative">
              <img :src="require('@/assets/competition/mailbox.png')" width="15px" style="position: absolute;top: 11px">
              <span class="footer-font" style="margin-left: 20px">意见反馈：{{websit.contactMail}}</span>
            </div>

          </div>
<!--        </el-col>-->
<!--        <el-col :span="12" :xs="24">-->
          <div style="display: flex">
<!--            <el-row>-->
<!--              &lt;!&ndash;残联去掉&ndash;&gt;-->
<!--              <el-col :span="isMobile?12:6" >-->
                <div style="text-align: center;display: grid;place-items: center;width: 150px" v-if="websit && websit.qrcodePath1">
                  <img :src="websit.qrcodePath1"  class="footer_img">
                  <div class="footer_fon">{{websit.qrcodeTitle1}}</div>
                </div>
<!--              </el-col>-->
<!--              <el-col :span="isMobile?12:6" >-->
                <div style="text-align: center;width: 150px"  v-if="websit && websit.qrcodePath2">
                  <img :src="websit.qrcodePath2"  class="footer_img">
                  <div class="footer_fon">{{websit.qrcodeTitle2}}</div>
                </div>
<!--              </el-col>-->
<!--              <el-col :span="isMobile?12:6" >-->
                <div style="text-align: center;width: 150px" v-if="websit && websit.qrcodePath3">
                  <img :src="websit.qrcodePath3"  class="footer_img">
                  <div class="footer_fon">{{websit.qrcodeTitle3}}</div>
                </div>
<!--              </el-col>-->
<!--            </el-row>-->
          </div>
      </div>
<!--        </el-col>-->
<!--      </el-row>-->
      <el-divider class="footer-divider"/>
      <div style="margin-left: 100px;" v-if="websit && websit.siteIntro" >
        <span class="footer-font">主办单位：{{websit.siteIntro}}</span>
      </div>
      <div style="margin-left: 100px;display: flex;width: 100%;position: relative">
        <div>
          <span  class="footer-font">技术支持：美亚联创（北京）科技有限公司&nbsp;&nbsp;恩数互联（北京）智能科技有限公司</span>
<!--          <span  class="footer-font">技术支持：恩数互联（北京）智能科技有限公司</span>-->
          <span class="footer-font" style="margin-left: 20px">Copyright © {{year}}</span>
          <span v-if="websit && websit.siteRecord" class="footer-font" style="margin-left: 20px">{{websit.siteRecord}}</span>
        </div>
        <div v-if="websit && websit.siteAddress">
          <span  class="footer-font"  style="position: absolute;right: 10%">{{websit.siteAddress}}</span>
        </div>
<!--        <div style="margin-left: 20px">-->
<!--          <span class="footer-font" >型号：MY-COWS</span>&lt;!&ndash;广州城市职业学院&ndash;&gt;-->
<!--        </div>-->
      </div>

    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import QRCode from 'qrcodejs2'
import constant from '../constant'
export default {
  props: {
    topHeight: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      marginTopHeight: 10,
      year: new Date().getFullYear(),
      dictInfo: {},
      isMobile: null,
      // qrUrl: constant.STUDENT_PATH + '/student/index.action'
      qrUrl: constant.URL_DOWN + '/studycenter'
    }
  },
  computed: {
    ...mapGetters(['footerList', 'siteIntro', 'websit'])
  },
  watch: {
    topHeight: {
      handler (val) {
        this.marginTopHeight = val
      },
      immediate: true
    }
  },
  created () {
    this.ismobile()
    // setTimeout(() => {
    //   this.qrCodeGeneration()
    // }, 300)
  },
  mounted () {
    this.$nextTick(function () {
      // this.qrCodeGeneration()
    })
  },
  methods: {
    ismobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      this.isMobile = flag
    },
    // 二维码生成
    qrCodeGeneration () {
      // if (this.websit) {
      //   this.qrUrl = this.websit.siteDomain + '/studycenter'
      // }
      // 生成二维码
      this.$nextTick(function () {
        document.getElementById('qrCodeUrl').innerHTML = ''
        let qrCodeUrl = new QRCode('qrCodeUrl', {
          width: 140,
          height: 140,
          text: this.qrUrl,
          colorDark: '#000000',
          colorLight: '#fff'
        })
        console.log(qrCodeUrl)
      })
    }
  }
}
</script>
<style lang="less" scoped >
  .footer-all{
    height: auto;
  }
  .ndata-footer{
    position: relative;
    line-height: 35px;
    z-index: 100;
    background-color: #2C2C2C;
    padding-bottom: 10px;
    /*height: 200px;*/
  }
  .footer-font{
    font-size: 14px;
    font-weight: normal;
    color: #999999;
  }
  .footer-divider{
    width: 92%;
    position: relative;
    left:5%;
    bottom: 7px;
    background: #999999;
  }
  /deep/.el-divider--horizontal{
    height: 1px!important;
    margin: 10px 0px!important;
  }
  .footer-content{
    margin-left: 100px;
  }
  @media (max-width: 950px) {
    .footer-content{
      margin-left: 40px;
    }
  }
  @media ( max-width : 950px){
    .footer-code{
      margin-left: 30px;
    }
  }
  .qrCodeUrl{
    width: 150px;
    height: 150px;
    background: #ffffff;
    margin-left: 20px;
  }
  #qrCodeUrl{
    padding: 5px;
  }
  .footer_img{
    width: 100px;
  }
  .footer_fon{
    font-size: 14px;
    line-height:25px;
    color: #999999
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue